import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import App from "./App";

import { Provider } from "react-redux";
import store from "./store";
import GlobalStateStore from "./GlobalState";
import "./index.scss";




ReactDOM.render(
  <BrowserRouter>
    <Provider store={GlobalStateStore}>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);
